import React from "react";
import Page from "./Page";
import logo from "../../assets/TMDWhite.png";
import copy from "../copy.json";

const Footer = () => {
  return (
    <Page background="#374567">
      <div className="footer-container">
        <div className="footer-description">
          <div>Copyright © 2020 by The Michigan Daily</div>
          <div className="credit">Stories compiled by Leah Graham and Sayali Amin.</div>
          <div className="credit">Developed by Naitian Zhou, Rimaz Khan and Parth Dhyani.</div>
          <div className="credit">Designed by Abha Panda, Jessica Chiu, Shannon Li and Celine Chen.</div>
        </div>
        <div className="header-main">
          <img src={logo} className="header-logo" onClick={(e) => {e.preventDefault(); window.location.href='https://michigandaily.com';}}/>
          {copy.hed}
        </div>
      </div>
    </Page>
  );
};

export default Footer;
